module.exports = __webpack_public_path__ + "assets/svg/Icons/32/repeat-blue-23cec5.svg";